import React from 'react';
import styles from './Heading.module.css';

export interface HeadingProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  children: React.ReactNode;
  className?: string;
  gradient?: boolean;
}

/**
 * Heading Component
 * Semantic heading with consistent styling
 */
export function Heading({
  as: Component = 'h2',
  children,
  className = '',
  gradient = false,
}: HeadingProps) {
  const classNames = [
    styles.heading,
    styles[Component],
    gradient && styles.gradient,
    className,
  ].filter(Boolean).join(' ');

  return <Component className={classNames}>{children}</Component>;
}
